const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age, AgeOrder}  = require("../../Constants");

class Lab extends Technology {
    constructor(age, techName, scienceCost, workerCost, multiplier){
        super(
            age,
            Lab.GetType(),
            techName,
            scienceCost,
            workerCost,
            {
                playerStateAltering:
                    (playerState) => {
                        playerState.scienceProductionCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetWorkerCount()*multiplier,
                        });
                        // Resources stored on it as a mine (Bill Gates): each blue token worth the lab's level
                        playerState.currentResourceCalculationDelegate.push({
                            Source: this,
                            Action: () => this.GetBlueCubeCount() * this.resourceValue,
                        });
                    },
            }
        )
        // What a blue token on it is worth when it is used as a mine (Bill Gates): its level
        this.resourceValue = Math.max(0, AgeOrder.indexOf(age));
    }
    static GetType = () => TechnologyTypes.Urban.Lab;
}

class Philosophy extends Lab {
    constructor(){
        super(Philosophy.GetAge(), Philosophy.GetName(), 0, 3, 1)
    }

    static GetInstance = () => new Philosophy();
    static GetAge = () => Age.AgeA;
    static GetName = () => TechnologyNames.Urban.Philosophy;
}

class Alchemy extends Lab {
    constructor(){
        super(Alchemy.GetAge(), Alchemy.GetName(), 4, 6, 2)
    }

    static GetInstance = () => new Alchemy();
    static GetAge = () => Age.Age1;
    static GetName = () => TechnologyNames.Urban.Alchemy;
}

class ScientificMethod extends Lab {
    constructor(){
        super(ScientificMethod.GetAge(), ScientificMethod.GetName(), 6, 8, 3)
    }

    static GetInstance = () => new ScientificMethod();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Urban.ScientificMethod;
}

class Computers extends Lab {
    constructor(){
        super(Computers.GetAge(), Computers.GetName(), 8, 11, 5)
    }

    static GetInstance = () => new Computers();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Urban.Computers;
}

module.exports = {
    Philosophy,
    Alchemy,
    ScientificMethod,
    Computers,
}